import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=f98ee6a8&scoped=true"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"
import style0 from "./PersonModal.vue?vue&type=style&index=0&id=f98ee6a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98ee6a8",
  null
  
)

export default component.exports